import {
    doLogin,
} from '../services/login';

export const LOGIN = 'LOGIN';
export const enter = (res: Object) => ({
    type: LOGIN,
    payload: res,
});

export const login = () =>
    (dispatch: Function) => doLogin()
        .then((res) => {
            dispatch(enter({ login: true }));
            return res;
        });